import { SEEN_ANNOUNCEMENT_IDS } from '@utils/constants';
import { filterActiveAnnouncements, mergeSeenIds, parseSeenIds, pruneSeenIds } from './announcementsLogic';
import { ANNOUNCEMENTS } from './content/announcements';

// The only module reading/writing the seen-announcements storage. Async on
// purpose: a future server-side backend (C_UserPreferences) can replace the
// implementation without changing any call site.

export async function getSeenAnnouncementIds(): Promise<string[]> {
    return parseSeenIds(localStorage.getItem(SEEN_ANNOUNCEMENT_IDS));
}

export async function markAnnouncementsSeen(ids: string[]): Promise<void> {
    const existing = parseSeenIds(localStorage.getItem(SEEN_ANNOUNCEMENT_IDS));
    const pruned = pruneSeenIds(
        mergeSeenIds(existing, ids),
        filterActiveAnnouncements(ANNOUNCEMENTS, new Date()));
    localStorage.setItem(SEEN_ANNOUNCEMENT_IDS, JSON.stringify(pruned));
}
